<div class="flex flex-col gap-2 min-w-80 h-[50vh]">
  <soft-ds-search-input
    class="shrink-0 mt-3 p-1"
    placeholder="Lieferart suchen..."
    [value]="search()"
    (valueChange)="search.set($event ?? '')"
  />

  @if (!loading() && distributionTypes().length === 0) {
    <p class="text-sm text-light px-1 shrink-0">Keine Lieferarten gefunden.</p>
  } @else if (!loading()) {
    <p class="text-sm text-light px-1 shrink-0">
      {{ distributionTypes().length }}
      {{ distributionTypes().length === 1 ? 'Lieferart' : 'Lieferarten' }} gefunden
    </p>
  } @else {
    <p class="text-sm text-light px-1 shrink-0">Lade Lieferarten...</p>
  }

  <div class="flex-1 flex flex-col gap-1.5 overflow-y-auto min-h-0 p-1">
    @if (loading()) {
      @for (_ of skeletonRows; track $index) {
        <soft-ds-item size="sm" variant="outline" class="min-h-15.5">
          <soft-ds-item-leading>
            <soft-ds-loading-skeleton [width]="32" [height]="32" [radius]="6" />
          </soft-ds-item-leading>
          <soft-ds-item-title>
            <soft-ds-loading-skeleton [width]="140" [height]="14" [radius]="4" />
          </soft-ds-item-title>
          <soft-ds-item-description>
            <soft-ds-loading-skeleton [width]="200" [height]="12" [radius]="4" />
          </soft-ds-item-description>
          <soft-ds-item-trailing>
            <soft-ds-loading-skeleton [width]="16" [height]="16" [radius]="999" />
          </soft-ds-item-trailing>
        </soft-ds-item>
      }
    }
    @for (type of distributionTypes(); track type.id) {
      <soft-ds-item
        size="sm"
        [variant]="selectedId() === type.id ? 'default' : 'outline'"
        [class.is-selected-row]="selectedId() === type.id"
        [interactive]="true"
        (activate)="selectDistributionType(type)"
      >
        <soft-ds-item-leading>
          <span
            class="inline-flex items-center justify-center size-8 rounded-md shrink-0"
            [class]="
              selectedId() === type.id
                ? 'bg-primary text-white'
                : 'bg-primary/10 text-primary'
            "
          >
            <soft-ds-icon [name]="type.icon" size="md" color="current" />
          </span>
        </soft-ds-item-leading>
        <soft-ds-item-title>
          {{ type.name }}
        </soft-ds-item-title>
        <soft-ds-item-description>
          {{ type.subtitle }}
        </soft-ds-item-description>
        <soft-ds-item-trailing>
          <div class="inline-flex items-center gap-2">
            @if (defaultDistributionTypeId() === type.id) {
              <soft-ds-badge variant="primary" size="sm">Standard</soft-ds-badge>
            }
            @if (selectedId() === type.id) {
              <soft-ds-icon name="fa-solid fa-circle-check" size="sm" color="brand" />
            } @else {
              <soft-ds-icon
                name="fa-regular fa-circle"
                size="sm"
                color="current"
                class="opacity-20"
              />
            }
          </div>
        </soft-ds-item-trailing>
      </soft-ds-item>
    }
  </div>
</div>

<ng-template #bottomTpl>
  @if (isEmbedded()) {
    <div class="flex items-center justify-end w-full mt-2 gap-2 p-1">
      <soft-ds-button
        variant="primary"
        size="md"
        (click)="create.emit(local())"
        data-testid="delivery-type-step-create"
      >
        {{ '#SALES.WIZARD.CREATE_DOCUMENT' | translate }}
      </soft-ds-button>
    </div>
  }
</ng-template>
